import { render, staticRenderFns } from "./BannerAspectRatio.vue?vue&type=template&id=12c4f79e&scoped=true&"
import script from "./BannerAspectRatio.vue?vue&type=script&lang=ts&"
export * from "./BannerAspectRatio.vue?vue&type=script&lang=ts&"
import style0 from "./BannerAspectRatio.vue?vue&type=style&index=0&id=12c4f79e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c4f79e",
  null
  
)

export default component.exports